module.exports = __webpack_public_path__ + "src/assets/textures/env/corn_cards/corn_stalk_01_card_2k_bake.png";